/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react/prop-types */
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import CircleButtons from '../../../atoms/circle-buttons';
import MobileCarousel from '../../../atoms/mobile-carousel-glu';
import { useScreenResizer } from '../../../../contexts/screen-resize-context';
import { PBSLink } from '../../../atoms/link';
import { buildLink } from '../../../../utils/locale';

const FreeToolCarousel = ({ trendingCourse, locale = 'en' }) => {
	const [center, setCenter] = useState(0);
	const [isMobile, setIsmobile] = useState();
	const imageStyle = [
		{
			zIndex: 30,
			transform: `translate(0%,0%) scale(0.8)`,
		},
		{
			zIndex: 20,
			transform: `translate(38%,5%) scale(0.7)`,
		},
		{
			zIndex: 10,
			transform: `translate(54%, 10%) scale(0.6)`,
		},
		{
			zIndex: 10,
			transform: `translate(-54%, 10%) scale(0.6)`,
		},
		{
			zIndex: 20,
			transform: `translate(-38%,5%) scale(0.7)`,
		},
	];
	const { width } = useScreenResizer();

	useEffect(() => {
		if (width < 768) {
			setIsmobile(true);
		} else {
			setIsmobile(false);
		}
	}, [width]);

	const Component = 'div';
	const [isHovered, setIsHovered] = useState(false);
	useEffect(() => {
		let timeoutId;
		if (!isHovered) {
			timeoutId = window.setTimeout(() => {
				setCenter(center < 4 ? center + 1 : 0);
			}, 5000);
		}

		return () => {
			clearTimeout(timeoutId);
		};
	}, [center, isHovered]);

	return isMobile ? (
		<MobileCarousel
			imageData={trendingCourse}
			imageStyle={imageStyle}
			setCenter={setCenter}
			center={center}
			locale={locale}
		/>
	) : (
		<div
			className="bg-brand-pale-400 cursor-pointer"
			onMouseEnter={() => setIsHovered(true)}
			onMouseLeave={() => setIsHovered(false)}
		>
			<div className="container  mx-auto max-w-m-screen pb-48 glumd:pb-96 glulgx:pb-48 glu2xl:pb-48 mt-10 relative">
				<div className="hidden items-center sm:block ">
					<h2 className=" text-center text-2xl lg:text-3xl xxl:text-4xl">
						Current trending courses
					</h2>
					<div className="relative flex aspect-[16/8] justify-center w-full lg:aspect-[16/7] h-auto">
						{trendingCourse.map((image, i) => {
							const index = (5 + i - center) % 5;
							return (
								<Component
									onClick={() => setCenter(i)}
									key={image.url}
									style={imageStyle[index]}
									className={clsx(
										'absolute w-[600px] h-[700px] glu2xl:h-[700px] glumsdsm:h-[700px] glumd:h-[700px]  glulgx:h-[700px] transition-all duration-500 shadow-2xl will-change-transform bg-white rounded-sm flex flex-col items-center justify-center',
										{
											'hover:shadow-[0_-20px_80px_rgba(150,150,150,0.5)] cursor-pointer':
												index !== 0,
										}
									)}
								>
									<div className="w-full h-full flex-col flex">
										<div className="relative h-[50%] w-full">
											<img
												src={
													image.thumbnailUrl ||
													'https://www.datocms-assets.com/64336/1686221516-5-glu-intro-blog.png'
												}
												alt={image.title}
												style={{
													width: '100%',
													height: '100%',
												}}
												className="object-cover rounded-t-sm glu2xl:rounded-t-sm"
											/>
											<div className="absolute mr-2 pl-2 pr-2 pt-1 pb-1 rounded-md bg-brand-pale-400 text-black top-2 right-0 gap-1 inline-flex items-center">
												<div className="w-2 h-2 bg-blue-500 rounded-full" />
												<p className="text-sm">
													{image.category?.title ||
														image.moreCategory
															?.title}
												</p>
											</div>
											<span className="absolute top-0 glulgx:text-md glu2xl:text-xl rounded-tl-sm  left-0 bg-blue-400 text-white p-3 text-md">
												Free
											</span>
										</div>
										<div className="flex-1 h-full flex flex-col">
											<h3 className="font-bold p-5 glulgx:text-lg glu2xl:text-xl  bg-white ">
												{image.title}
											</h3>
											<p className="text-sm  text-gray-600 p-5 -mt-3 bg-white glu2xl:text-lg ">
												{image.intro}
											</p>
											<div className="grid flex-1  justify-center items-center grid-cols-2 gap-2 bg-white p-5 ">
												<div>
													<PBSLink
														to={buildLink(
															locale,
															`/elearning/${
																image.category
																	?.slug ||
																image
																	.moreCategory
																	?.slug
															}/${image.slug}`
														)}
														variant="White"
														size="Small"
														className="justify-center ml-2 mt-auto text-blue-400 glulgx:text-sm glu2xl:text-xl"
													>
														Start Course →
													</PBSLink>
												</div>
												<div className="text-sm ml-6">
													<p>
														<span className="text-success-500 font-bold mr-1">
															{' '}
															✓
														</span>
														CPD Accredited
													</p>
													<p>
														<span className="text-success-500 font-bold mr-1">
															{' '}
															✓
														</span>
														Certificate on
														completion
													</p>
													<p>
														<span className="text-success-500 font-bold mr-1">
															{' '}
															✓
														</span>
														3000+ completed
													</p>
												</div>
											</div>
											<p className="text-sm glu2xl:w-full glulgx:rounded-b-sm glu2xl:rounded-b-sm bg-grey-400/20 p-3">
												🕒 Duration:{' '}
												{image.timeToWatchInMinutes ? (
													<>
														{
															image.timeToWatchInMinutes
														}{' '}
														Minutes
													</>
												) : null}
											</p>
										</div>
									</div>
								</Component>
							);
						})}
					</div>
					<div className="absolute mt-auto text-center bottom-16 right-0 left-0 w-full">
						<CircleButtons
							numberOfButtons={trendingCourse}
							clickHandler={setCenter}
							center={center}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default FreeToolCarousel;
